module.exports = __webpack_public_path__ + "img/AB5_7274.30344820.jpg";